import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("grubpe_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      // optional: redirect to login
    }
    return Promise.reject(e);
  }
);

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return JSON.stringify(d);
};

/** Indian numbering format helpers — lakhs/crores convention.
 *  inr(n)        → ₹1,23,456 (no decimals — for order counts, qty, integer headlines)
 *  inrMoney(n)   → ₹1,23,456.78 (2 dp — use for revenue, P&L, settlements, invoices)
 *  inrCount(n)   → 1,23,456 (Indian-grouped integer — for order counts without ₹)
 *  inrDecimal(n) → 1,23,456.78 (Indian-grouped, 2 dp, no ₹)
 */
const _IN = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });
const _IN_2DP = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const inr = (n) => `₹${_IN.format(Math.round(Number(n || 0)))}`;
export const inrMoney = (n) => `₹${_IN_2DP.format(Number(n || 0))}`;
export const inrCount = (n) => _IN.format(Math.round(Number(n || 0)));
export const inrDecimal = (n) => _IN_2DP.format(Number(n || 0));
